import styled from 'styled-components';
import color from 'tinycolor2';
import {
  Menu as MenuComponent,
  ListItemColumn as ListItemColumnComponent,
} from '@pearsontechnology/aero-components';

export const Label = styled.span`
  margin-right: 10px;
  padding: 6px 10px;
  height: 26px;
  color: ${(props) => props.major ? props.theme['color.primary'] : props.theme['chip.text.color']};
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.8px;
  background-color: ${(props) => props.major
    ? color(props.theme['color.primary']).setAlpha(0.2).toString()
    : color(props.theme['color.text.body']).setAlpha(0.1).toString()};
  border-radius: 13px;
  line-height: 14px;
  text-decoration: ${(props) => props.unpublished ? 'line-through' : 'none'};
`;

export const MajorUpdateLabel = styled.div`
  align-items: center;
  display: inline-flex;
  font-size: 12px;
  color: rgba(35, 151, 244, 0.9);
  font-weight: bold;
  letter-spacing: 1px;
`;

export const ContentWrapper = styled.div`
  padding: 0 40px 30px;
`;

export const HeaderWrapper = styled.div`
  color: ${(props) => props.theme['version.list.column.title.color']};
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;

export const EmptyAction = styled.div`
  width: 34px;
`;

export const ListItemColumnRightAlign = styled(ListItemColumnComponent)`
  justify-content: flex-end;
`;
